import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useGetProfileInfo = (userToken) => {
  const baseUrl = useBaseUrl();
  const [userData, setUserData] = useState(null);
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await Axios.get(`${baseUrl}/profile/update/`, {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        });
        setUserData(response.data);
      } catch (error) {
        console.log("Error fetching user data", error);
      }
    };
    if (userToken) {
      fetchUserData();
    }
  }, [baseUrl, userToken]);
  return { userData };
};
export default useGetProfileInfo;
